import { render } from "./SellingsForm.vue?vue&type=template&id=38eb87aa&scoped=true"
import script from "./SellingsForm.vue?vue&type=script&lang=js"
export * from "./SellingsForm.vue?vue&type=script&lang=js"

import "./SellingsForm.vue?vue&type=style&index=0&id=38eb87aa&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38eb87aa"]])

export default __exports__